import { render, staticRenderFns } from "./Dota.vue?vue&type=template&id=c73cfb72&scoped=true&"
import script from "./Dota.vue?vue&type=script&lang=js&"
export * from "./Dota.vue?vue&type=script&lang=js&"
import style0 from "./Dota.vue?vue&type=style&index=0&id=c73cfb72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73cfb72",
  null
  
)

export default component.exports